<template>
  <el-autocomplete
    ref="input"
    class="inline ACustomerSelector"
    v-model="val"    
    value-key="name"
    :placeholder="placeholder"
    :size="size"
    :fetch-suggestions="searchQuery"
    :trigger-on-focus="false"
    :disabled="disabled"
    :debounce="0"
    :clearable="clearable"
    @input="handleInput"
    @select="handleSelect"
    @clear="handleClear"
    
    @keydown.enter.native="searchCode"
  />
</template>
<script>
import $ from 'jquery'

import { mapGetters } from "vuex";
import { auto_complete } from "@/common/mixins/auto_complete";

export default {
  name: "ACustomerSelector",
  mixins: [auto_complete],
  data() {
    return {
      isChangable: false,
      selfInput: undefined,
      changeCustomer: null,
    };
  },
  props: {
    buyer: {
      type: Boolean,
      default: false
    },
    seller: {
      type: Boolean,
      default: false
    },
    service: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: '거래처'
    },
    confirmChange: {
      type: Boolean,
      default: false
    },
  },  
  computed: {
    ...mapGetters(["table_customer"]),
    items: function() {
      let flags = [];
      if (this.seller) {  //매출처
        flags.push(1);
      }
      if (this.buyer) {   //매입처
        flags.push(2);
      }
      if (this.seller || this.buyer) {
        flags.push(3);
      }    
      if (this.service) {
        flags.push(5);
      }      
      return flags.length > 0? 
        this.table_customer.filter(c => flags.includes(c.type_flag)):
        this.table_customer;
    },
  },
  mounted() {
    let ariaOwns = $(this.$el).attr('aria-owns');
    this.selfInput = $('[aria-owns="' + ariaOwns + '"] input');
  },
  created() {
    /**
     * ERP-422 수주 등록 페이지 거래처 변경 처리
     * 거래처 변경에 대한 이벤트 처리
     */
    this.EventBus.$on('changeCustomer', this.eventmethod);
  },
  beforeDestroy() {
    this.EventBus.$off('changeCustomer', this.eventmethod);
  },
  methods: {
    eventmethod(param) {
      if (param) {
        this.changeCustomer = param;
        setTimeout( () => {
          this.selfInput.blur();
          if (this.util.confirm(this, "거래처", "새로 등록 하시겠습니까?",
            this.handleChangeOK, this.handleChangeCancel));
        }, 100);
      }
    },
    handleBlur() {
      this.$emit("select", this.results[0]);
    },
    handleFocus() {      
      if (!this.confirmChange) { return; }
      if (!this.val) { return; }
      if (this.isChangable) { 
        this.isChangable = false;
        return; 
      }
      this.selfInput.blur();
      if (this.util.confirm(this, "거래처", "거래처를 변경하시겠습니까?",
        this.handleChangeOK, this.handleChangeCancel));
    },
    handleChangeOK() {
      this.isChangable = true;
      this.selfInput.focus();
      this.$emit('acceptedChange', this.changeCustomer)
    },
    handleChangeCancel() {
      this.$emit('canceledChange', this.changeCustomer)
    },
  }
};
</script>

<style lang="scss" scoped>
.ACustomerSelector {
  width: calc(100% - 20px);
}
</style>
